<style scoped>
</style>

<template>
  <AppLayout class="set-location-component" style="position:relative; padding-bottom:0">
    <Row type="flex" justify="center">
      <Col :xs="24" :sm="24" :md="24" :lg="24">
        <SetLocationMapComponent :geoLocation="checkIfEmptyHomeLocation(profileInfo, locationType)"
          @emitUpdate="onUpdate" :submitLabel="'Set ' + locationType + ' location'" :readOnly="readOnly"
          @hideMarker="hideMarker" :type="locationType"></SetLocationMapComponent>
      </Col>
    </Row>
  </AppLayout>
</template>

<script>
import SetLocationMapComponent from "@/components/SetLocationMapComponent";
import _ from "lodash";

export default {
  name: "SetLocationComponent",
  data() {
    return {
      pageLoader: false,
      geoLocation: {
        lat: 0,
        long: 0
      },
      zoom: 4,
      readOnly: false
    };
  },
  components: {
    SetLocationMapComponent
  },
  watch: {
    $route(to, from) {
      this.readOnly = to.query.readonly;
    }
  },
  computed: {
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    locationType: {
      get() {
        return this.$route.query.type;
      }
    }
  },
  mounted() {
    if (this.$route.query.readonly === "true") this.readOnly = true;
    else this.readOnly = false;
  },
  methods: {
    onUpdate(data) {
      data.geoLocation["category"] = data.type;
      this.$store.dispatch("user/setLocation", data.geoLocation).then(res => {
        this.$router.replace({
          query: { type: this.locationType, readonly: true }
        });
        this.$Message({
          closable: true,
          durationInSec:10,
          title: { content:'Successfull' },
          icon: 'alert',
          message: { content: 'Location set succesfully.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });             
      });
    },

    checkIfEmptyHomeLocation(data, type) {
      if (_.get(data, "places." + type)) {
        this.geoLocation.lat = data.places[type].latitude;
        this.geoLocation.long = data.places[type].longitude;

        return this.geoLocation;
      }
    },

    hideMarker() {
      this.$router.replace({
        query: { type: this.locationType, readonly: false }
      });
    }
  }
};
</script>
